// @flow
import { PRODUCT_WELLNESS } from 'Client/cms/toolkit/constants';
import { ProductWellnessLine } from 'Components/lines/product-wellness-line/ProductWellnessLine';
import { productWellnessResolver } from './productWellness.resolver';

export const productWellnessDescriptor = {
  name: PRODUCT_WELLNESS,
  component: ProductWellnessLine,
  resolve: productWellnessResolver.resolve,
};
